module.exports = "## Scrum\n\n> 面包屑\n\n### 使用说明\n\n* `items`\n    * Array<{text: 'textInfo', name: 'levelId'}>\n\n\n* 事件名称\n    * `link-change`\n\n\n```js\nimport Scrum from 'smui/Scrum'\n\nconst scrumList = [\n    {text: '计划', name: 'plan'},\n    {text: '单元', name: 'unit'},\n    {text: '关键词', name: 'keyword'}\n]\n\nexport default {\n    data() {\n        return {\n            params: {\n                items: scrumList\n            }\n        }\n    },\n    components: {\n        Scrum\n    }\n}\n```"


//////////////////
// WEBPACK FOOTER
// ../~/.0.5.1@raw-loader!./docs/components/Scrum.md
// module id = 406
// module chunks = 1 4